import { DataTableColumn } from "../../data-table.config";

export class DataTableColumnWaitingTime extends DataTableColumn {
    value!: (item: any) => string;

    constructor(params : any)
    {
        super();
        Object.assign(this, params);
    }
}
